import {
    createSlice
} from "@reduxjs/toolkit";
import {
    getTransaction,
} from "./thunk";
export const initialState = {
    data:[],
    error: "", // for error message
    loading: false,
};

const workSlice = createSlice({
    name: "works",
    initialState,

    extraReducers: (builder) => {
        builder
            .addCase(getTransaction.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getTransaction.fulfilled, (state, action) => {
                state.data = action.payload;
                state.loading = false;
            })
            .addCase(getTransaction.rejected, (state, action) => {
                state.error = action.payload?.error || null;
                state.loading = false;
            })
    }
});

// export const {
//     updateBusinessInfo
// } = businessInfoSlice.actions

export default workSlice.reducer;